import { isNil } from 'lodash';

export const booleanTranslationFormatter = (translationPrefix = 'common') => params => {
  if (isNil(params.value)) {
    return null;
  }

  return `${translationPrefix}.${params.value ? 'yes' : 'no'}`;
};
